import React from 'react';
import UserCard from './UserCard';

const UsersList = ({ t, onClickUser, shipperId, users }) => {
  return (
    <>
      {users.map((user, index) => (
        <UserCard
          user={user}
          shipperId={shipperId}
          isFirst={index === 0}
          key={user.id}
          onClick={() => onClickUser(user)}
          t={t}
        />
      ))}
    </>
  );
};

export default UsersList;
